export const skillsTranslations = {
  es: {
    section_title: 'Habilidades',
    languages: 'Lenguajes',
    frameworks: 'Frameworks y librerías',
    databases: 'Bases de datos',
    others: 'Otros',
  },
}
